import React, { useState, useEffect } from 'react';
import * as calcs from '../Formeln';
import ZweiAuf from '../assets/Mehrere.PNG';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';
import KraftAufrecht from '../assets/KraftAufrecht.png';
import KraftLiegend from '../assets/KraftLiegend.png';
import './MCalc.css';

function MCalc() {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const Länge = useFlexionStore((state) => state.Länge);
  const ErsterPunktDistanz = useFlexionStore((state) => state.ErsterPunktDistanz);
  const ErsterPunktLast = useFlexionStore((state) => state.ErsterPunktLast);
  const ZweiterPunktDistanz = useFlexionStore((state) => state.ZweiterPunktDistanz);
  const ZweiterPunktLast = useFlexionStore((state) => state.ZweiterPunktLast);
  const DritterPunktDistanz = useFlexionStore((state) => state.DritterPunktDistanz);
  const DritterPunktLast = useFlexionStore((state) => state.DritterPunktLast);
  const SelectedProfile = useFlexionStore((state) => state.SelectedProfile);
  const SelectedProfileFetched = useFlexionStore((state) => state.SelectedProfileFetched);
  const [text, settext] = useState(getText(Sprache));

  function CalculateHochkant() {
    let ersterHochkant = calcs.AufliegendVersetztePunktLastHochkant(
      ErsterPunktLast,
      Länge,
      ErsterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
    let zweiterHochkant = calcs.AufliegendVersetztePunktLastHochkant(
      ZweiterPunktLast,
      Länge,
      ZweiterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
    let dritterHochkant = calcs.AufliegendVersetztePunktLastHochkant(
      DritterPunktLast,
      Länge,
      DritterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
    const eigenHochkant = calcs.EigenAufHoch(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Iy
    );

    if (Number.isNaN(ersterHochkant)) ersterHochkant = 0;
    if (Number.isNaN(zweiterHochkant)) zweiterHochkant = 0;
    if (Number.isNaN(dritterHochkant)) dritterHochkant = 0;

    const ergHochkant = ersterHochkant + zweiterHochkant + dritterHochkant + eigenHochkant;
    return Math.round(ergHochkant * 100) / 100;
  }

  function CalculateQuer() {
    let ersterQuer = calcs.AufliegendVersetztePunktLastQuer(
      ErsterPunktLast,
      Länge,
      ErsterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
    let zweiterQuer = calcs.AufliegendVersetztePunktLastQuer(
      ZweiterPunktLast,
      Länge,
      ZweiterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
    let dritterQuer = calcs.AufliegendVersetztePunktLastQuer(
      DritterPunktLast,
      Länge,
      DritterPunktDistanz,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
    const eigenQuer = calcs.EigenAufQuer(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Ix
    );

    if (Number.isNaN(ersterQuer)) ersterQuer = 0;
    if (Number.isNaN(zweiterQuer)) zweiterQuer = 0;
    if (Number.isNaN(dritterQuer)) dritterQuer = 0;

    const ergQuer = ersterQuer + zweiterQuer + dritterQuer + eigenQuer;
    return Math.round(ergQuer * 100) / 100;
  }

  function ClassNames(func) {
    let val = 0;
    if (SelectedProfileFetched) val = func();
    if (val > Länge / 250) return ' Limit';
    return '';
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <div className='MCalcContainer'>
      <img className='IMG' src={ZweiAuf} alt='Logo' />
      <div className='MCalcResultCont'>
        <h3>{text.MCalc.Result}</h3>
        <img className='KraftAuf' src={KraftAufrecht} alt='Logo' />
        <span className={`MCalcResult Hoch${ClassNames(CalculateHochkant)}`}>
          : {SelectedProfileFetched ? CalculateHochkant() : '0'} mm
        </span>
        <img className='KraftLieg' src={KraftLiegend} alt='Logo' />
        <span className={`MCalcResult Quer${ClassNames(CalculateQuer)}`}>
          : {SelectedProfileFetched ? CalculateQuer() : '0'} mm
        </span>
      </div>
    </div>
  );
}

export default MCalc;
